module.exports = __webpack_public_path__ + "img/network_icon.47c038ef.svg";